export interface PlaybackEventsFilters {
  eventType: string
  startDate: string
  endDate: string
  limit: number
  offset: number
}

export interface PlaybackEventsBaseVariables {
  organizationId?: string
  zoneId?: string
  deviceId?: string
  trackId?: string
}

export function buildPlaybackEventsVariables(
  baseVariables: PlaybackEventsBaseVariables,
  filters: PlaybackEventsFilters
) {
  return {
    ...baseVariables,
    eventTypes: filters.eventType && filters.eventType !== 'all' ? [filters.eventType] : undefined,
    startDate: filters.startDate || undefined,
    endDate: filters.endDate || undefined,
    limit: filters.limit,
    offset: filters.offset,
  }
}
